

	import { Component } from 'vue-property-decorator';
	import { BaseAppView } from '@shared/views/BaseAppView';
	import { container } from 'inversify-props';
	import { User, UserCreateRequest } from '@shared/models';
	import firebase from 'firebase';

	@Component({})
	export default class Register extends BaseAppView {


		public displayName: string = '';
		public email: string = '';
		public password: string = '';
		public state: string = 'not set';
		public inviteCode: string = '';
		public registering: boolean = false;

		public $refs!: {
			form: any,
		};

		public async mounted() {
			this.loading = true;
			firebase.auth().onAuthStateChanged((user) => {
				if (user) {
					this.$router.push({ name: 'home' });
				}
			});

			try {
				if (this.settings.requireInviteForSignup && !this.$route.query.code) {
					this.state = 'uninvited';
					return;
				}
				this.inviteCode = this.$route.query.code.toString();
				const result = await this.$api.invitationService.check(this.$route.query.code.toString());
				this.state = result.isClaimed ? 'claimed' : 'valid';
			} catch (err) {
				this.errorMessage = 'SkateLurker is currently set to invite only while we get things ready for production. Sorry for the delay.';
				this.state = 'error';
			} finally {
				this.loading = false;
			}
		}

		public async register() {
			try {
				this.registering = true;
				const user = new UserCreateRequest({ email: this.email, displayName: this.displayName, password: this.password, invitationCode: this.inviteCode });
				const result = await this.$api.userService.signup(user);
				await firebase.auth().signInWithEmailAndPassword(this.email, this.password);
				this.$router.push({ name: 'login' });
				this.notification.success('Thank you for signing up for SkateLurker!');
			} catch (err) {
				if (err.response?.data?.detail) {
					this.notification.error(err.response.data.detail);
				} else {
					this.notification.error('An error occurred while registering your account');
				}
				
			} finally {
				this.loading = false;
				this.registering = false;
			}
		}


	}

